import {
  getList,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "./answer";

export interface MultiChoiceAnswerV1DTO {
  selectedChoices: AnswerDTO[];
}

export class MultiChoiceAnswerV1 {
  readonly isMultiChoiceAnswerV1MultiChoiceAnswerV1: boolean = true;

  readonly selectedChoices: Answer[];


  constructor(
  selectedChoices: Answer[]
  ) {
    this.selectedChoices = selectedChoices;
  }

  static fromDTO(dto: MultiChoiceAnswerV1DTO): MultiChoiceAnswerV1 {
    const selectedChoices = getList<AnswerDTO, Answer>(
      dto,
      "selectedChoices",
      Answer.fromDTO,
      InvalidMultiChoiceAnswerV1SelectedChoicesError
    );
    return new MultiChoiceAnswerV1(
      selectedChoices
    );
  }

  toDTO(): MultiChoiceAnswerV1DTO {
    const dto: MultiChoiceAnswerV1DTO = {
        selectedChoices: this.selectedChoices.map((e: Answer) => { return e.toDTO() })
    };
    return dto;
  }
  }

MultiChoiceAnswerV1.prototype.toString = function toString(): string {
  return `MultiChoiceAnswerV1(selectedChoices='${this.selectedChoices}')`;
};

export class InvalidMultiChoiceAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiChoiceAnswerV1Error";
  }
}
export class InvalidMultiChoiceAnswerV1SelectedChoicesError extends InvalidMultiChoiceAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidMultiChoiceAnswerV1SelectedChoicesError";
  }
}
